import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=0d2c1e20&lang=pug"
import script from "./SubscriptionForm.vue?vue&type=script&lang=ts"
export * from "./SubscriptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports